import {ActionCreator, createAction} from '@packages/utilities/create-action';
import {
  CREATE_WEBHOOK_REQUESTED,
  DELETE_WEBHOOK_REQUESTED,
  FETCH_WEBHOOKS_REQUESTED,
  WEBHOOK_SECRET_MODAL_CLOSED,
} from '@packages/systems/designer/actions';
import {WebhookTriggerType} from '@packages/systems/designer/site-data';

export const fetchWebhooksRequested: ActionCreator<
  typeof FETCH_WEBHOOKS_REQUESTED,
  void
> = createAction(FETCH_WEBHOOKS_REQUESTED);

export const deleteWebhookRequested: ActionCreator<
  typeof DELETE_WEBHOOK_REQUESTED,
  {
    webhookId: string;
  }
> = createAction(DELETE_WEBHOOK_REQUESTED);

export const secretModalClosed: ActionCreator<
  typeof WEBHOOK_SECRET_MODAL_CLOSED,
  void
> = createAction(WEBHOOK_SECRET_MODAL_CLOSED);

export const createWebhookRequested: ActionCreator<
  typeof CREATE_WEBHOOK_REQUESTED,
  {
    url: string;
    triggerType: WebhookTriggerType;
    version: 'v1' | 'v2';
  }
> = createAction(CREATE_WEBHOOK_REQUESTED);
